import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Renders Pam's assistant replies as constrained markdown — the same
 * react-markdown + remark-gfm stack the blog uses (BlogPost.tsx).
 *
 * Deliberately narrow: paragraphs, bold/italic, lists, links, inline code.
 * Raw HTML is skipped; disallowed elements are unwrapped to their text.
 * Safe to re-render per streaming chunk (messages are short).
 */

const ALLOWED_ELEMENTS = [
  'p',
  'strong',
  'em',
  'ul',
  'ol',
  'li',
  'a',
  'blockquote',
  'code',
  'br'
];

interface PamMarkdownProps {
  content: string;
}

const PamMarkdown: React.FC<PamMarkdownProps> = ({ content }) => (
  <div
    className={
      'space-y-2 break-words ' +
      '[&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-5 [&_ol]:pl-5 [&_li]:my-0.5 ' +
      '[&_a]:underline [&_a]:text-accent-700 ' +
      '[&_blockquote]:border-l-2 [&_blockquote]:border-accent-300 [&_blockquote]:pl-3 [&_blockquote]:text-neutral-600 ' +
      '[&_code]:font-mono [&_code]:text-[0.85em] [&_code]:bg-neutral-100 [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded'
    }
  >
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      allowedElements={ALLOWED_ELEMENTS}
      unwrapDisallowed
      skipHtml
    >
      {content}
    </ReactMarkdown>
  </div>
);

export default PamMarkdown;
